import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import Amplify from 'aws-amplify';
import {Authenticator} from '@aws-amplify/ui-react';
import awsConfig from './aws-exports';
import {BrowserRouter as Router, Route, Routes, useLocation,} from "react-router-dom";
import '@aws-amplify/ui-react/styles.css';
import './assets/sass/apply/styles.scss'
import reportWebVitals from './reportWebVitals';
import ClientApp from "./components/app/ClientApp";
import Login from "./components/app/Login";
import SignUpFlow from "./components/app/register/SignUpFlow";

import Dashboard from "./components/routes/Dashboard";
import ApplyMenu from "./components/routes/ApplyMenu";
import Section from "./components/routes/Section";
import ApplyAppMenu from "./components/routes/ApplyAppMenu";
import UploadMenu from "./components/routes/UploadMenu";
import UploadAppMenu from "./components/routes/UploadAppMenu";
import Upload from "./components/routes/Upload";

const updatedAwsConfig = {
    ...awsConfig,
}
Amplify.configure(updatedAwsConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));

function ScrollToTop() {
    const {pathname} = useLocation();
    useEffect(() => {
        document.getElementById('root').scrollTo(0, 1);
    }, [pathname]);
    return null;
}
root.render(
    <Authenticator.Provider>
        <Router>
            <ScrollToTop/>
            <Routes>
                <Route path='/' element={<ClientApp/>}>
                    <Route index element={<Dashboard/>}/>

                    <Route path='apply'>
                        <Route index element={<ApplyMenu/>}/>
                        <Route path=':section'>
                            <Route index element={<Section applicant={false}/>}/>
                            <Route path='steps' element={<Section applicant={false} steps={true}/>}/>
                            <Route path='end' element={<Section applicant={false} end={true}/>}/>
                        </Route>
                    </Route>

                    <Route path='apply-1'>
                        <Route index element={<ApplyAppMenu applicant={1}/>}/>
                        <Route path=':section'>
                            <Route index element={<Section  key='section-index'  applicant={1} n={1}/>}/>
                            <Route path='steps' element={<Section  key='section-steps'  applicant={1} steps={true} n={2}/>}/>
                            <Route path='any' element={<Section key='section-any' applicant={1} any={true} n={5}/>}/>
                            <Route path='end' element={<Section key='section-instance-end' applicant={1} end={true} n={7}/>}/>
                            <Route path=':index'>
                                <Route index element={<Section key='section-instance' applicant={1} n={4}/>}/>
                                <Route path='steps' element={<Section key='section-instance-steps' applicant={1} steps={true} n={3}/>}/>
                                <Route path='end' element={<Section key='section-instance-end' applicant={1} end={true} n={6}/>}/>
                            </Route>
                        </Route>
                    </Route>

                    <Route path='apply-2'>
                        <Route index element={<ApplyAppMenu applicant={2}/>}/>
                        <Route path=':section'>
                            <Route index element={<Section key='section-index'  applicant={2} n={1}/>}/>
                            <Route path='steps' element={<Section key='section-steps'  applicant={2} steps={true} n={2}/>}/>
                            <Route path='any' element={<Section key='section-any' applicant={2} any={true} n={5}/>}/>
                            <Route path='end' element={<Section key='section-instance-end' applicant={2} end={true} n={7}/>}/>
                            <Route path=':index'>
                                <Route index element={<Section key='section-instance' applicant={2} n={4}/>}/>
                                <Route path='steps' element={<Section key='section-instance-steps' applicant={2} steps={true} n={3}/>}/>
                                <Route path='end' element={<Section key='section-instance-end' applicant={2} end={true} n={6}/>}/>
                            </Route>
                        </Route>
                    </Route>

                    <Route path='upload'>
                        <Route index element={<UploadMenu/>}/>
                        <Route path=':section' element={<Upload applicant={false}/>}/>
                    </Route>
                    <Route path='upload-1'>
                        <Route index element={<UploadAppMenu applicant={1}/>}/>
                        <Route path=':section' element={<Upload applicant={1}/>}/>
                    </Route>
                    <Route path='upload-2'>
                        <Route index element={<UploadAppMenu applicant={2}/>}/>
                        <Route path=':section' element={<Upload applicant={2}/>}/>
                    </Route>

                </Route>
                <Route path='/login' element={<Login/>}/>
                <Route path='/start' element={<SignUpFlow/>}/>
                <Route path='*' element={<Login/>}/>
            </Routes>
        </Router>
    </Authenticator.Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
